(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/initials/assets/javascripts/initials.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/initials/assets/javascripts/initials.js');
"use strict";

const {
  useMemo
} = React;
const {
  ReactIcon
} = svs.ui;
const BadgeEl = _ref => {
  let {
    badgeIcon,
    badgeCount,
    isMyBets,
    hasHighestScore,
    isContributing
  } = _ref;
  const classNames = [];
  if (badgeIcon && badgeIcon.length > 0) {
    return React.createElement("div", {
      className: "badged-initials-icon"
    }, React.createElement(ReactIcon, {
      color: "fc-white",
      icon: badgeIcon,
      size: "100"
    }));
  }
  if (Number.isInteger(badgeCount)) {
    const styles = {};
    if (isMyBets) {
      classNames.push('badged-initials-count-mybets');
      if (hasHighestScore) {
        classNames.push('has-highest-score');
      }
      if (!isContributing) {
        classNames.push('is-not-contributing');
      }
    }
    return React.createElement("div", {
      className: "".concat(isMyBets ? classNames.join(' ') : 'badged-initials-count'),
      style: styles
    }, badgeCount);
  }
  return null;
};
const Initials = _ref2 => {
  let {
    badgeCount,
    badgeIcon,
    className,
    firstname,
    hasHighestScore = false,
    isAnonymous,
    isContributing = true,
    isMyBets = false,
    isSimpleDiv = false,
    lastname
  } = _ref2;
  const initials = () => {
    if (isAnonymous) {
      return 'AN';
    }
    const firstLetterFirstName = firstname && firstname.length > 0 ? firstname[0] : '';
    const firstLetterLastName = lastname && lastname.length > 0 ? lastname[0] : '';
    return (firstLetterFirstName + firstLetterLastName).toUpperCase();
  };
  const classes = ["".concat(isMyBets ? 'badged-initials-mybets' : 'badged-initials')];
  if (className && className.length > 0) {
    classes.push(className);
  }
  const title = useMemo(() => {
    const title = !isAnonymous ? "".concat(firstname, " ").concat(lastname).trim() : 'Anonym';
    return title.length > 0 ? title : undefined;
  }, [firstname, lastname, isAnonymous]);
  const initial = initials();
  if (isSimpleDiv) {
    return React.createElement("abbr", {
      className: "badged-initials-simple ".concat(className || '').trim(),
      title: title
    }, initial);
  }
  return React.createElement("abbr", {
    className: classes.join(' '),
    title: title
  }, React.createElement(BadgeEl, {
    badgeCount: badgeCount,
    badgeIcon: badgeIcon,
    hasHighestScore: hasHighestScore,
    isContributing: isContributing,
    isMyBets: isMyBets
  }), initial);
};
setGlobal('svs.components.marketplaceShared.initials.Initials', Initials);

 })(window);